export default "__VITE_ASSET__BI9nCuma__$_?nuxt_component=async&nuxt_component_name=SvgoMoc&nuxt_component_export=default__"